import { FormValues } from "./types";

export const INITIAL_VALUES: FormValues = {
  accountHolderId: -1,
  bankName: "",
  country: "",
  accountNameMatches: null,
  bankAccountName: "",
  explanation: "",
  accountHolderType: "",
  accountHolderFirstName: "",
  accountHolderMiddleName: "",
  accountHolderLastName: "",
  accountHolderLegalName: "",
  showBankAndCountry: true,
};
